import Reveal from '@/components/base/Reveal';
import { districts } from '@/mocks/homeData';

function DistrictIndex() {
  return (
    <section id="districts" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl">
          <Reveal>
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div>
                <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-600 uppercase tracking-widest">
                  <i className="ri-node-tree" />
                  District Index
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                  板块速览 · 分区索引
                </h2>
                <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 font-label leading-relaxed">
                  八个大分区按主题铺开，每个分区标好了子版数量与条目规模。先看整体，再决定去哪一区。
                </p>
              </div>
              <a
                href="#featured"
                className="inline-flex items-center gap-1 h-10 px-4 rounded-md border border-background-300 text-sm font-label text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap shrink-0"
              >
                看精选频道
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </Reveal>

          <div className="mt-9 border-t border-background-200">
            {districts.map((item, index) => (
              <Reveal key={item.code} delay={index * 40}>
                <a
                  href="#subforums"
                  className="group grid grid-cols-1 sm:grid-cols-[80px_1fr_auto] items-start sm:items-center gap-3 sm:gap-5 py-5 border-b border-background-200 hover:bg-background-100 transition-colors px-2 rounded-md"
                >
                  <div className="flex items-center gap-3">
                    <span className="font-heading text-lg font-bold text-foreground-400 group-hover:text-primary-600 transition-colors">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className="sm:hidden inline-flex items-center h-6 px-2 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-label">
                      {item.code}
                    </span>
                    {item.hot && (
                      <span className="inline-flex items-center gap-1 h-6 px-2 rounded-full bg-primary-100 text-primary-700 text-[11px] font-label">
                        <i className="ri-fire-line" />
                        热
                      </span>
                    )}
                  </div>

                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <h4 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                        {item.name}
                      </h4>
                      <span className="hidden sm:inline-flex items-center h-6 px-2 rounded-full bg-background-200 text-foreground-700 text-[11px] font-label">
                        {item.code}
                      </span>
                    </div>
                    <p className="mt-1 text-sm text-foreground-600 font-label leading-relaxed">{item.desc}</p>
                  </div>

                  <div className="flex items-center gap-6 sm:gap-8">
                    <div className="text-left sm:text-right">
                      <p className="font-heading text-xl font-bold text-foreground-950">{item.subs}</p>
                      <p className="text-[11px] font-label text-foreground-500">子版</p>
                    </div>
                    <div className="text-left sm:text-right">
                      <p className="font-heading text-xl font-bold text-foreground-950">{item.posts}</p>
                      <p className="text-[11px] font-label text-foreground-500">条目</p>
                    </div>
                    <span className="flex items-center justify-center w-8 h-8 rounded-md bg-background-100 text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors shrink-0">
                      <i className="ri-arrow-right-up-line" />
                    </span>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default DistrictIndex;